import React, {useState} from 'react';
import styled from "styled-components";
import {Button, Form, Input, Modal, ModalProps} from "antd";
import {MaskedInput} from "antd-mask-input";
import Close2SVG from "../icons/Close2SVG";
import store from "../redux/store";
import {makeUnauthorizedOrderAction} from "../redux/actions/pageActions";

type FastOrderPosition = {
    Id: number;
    Count: number;
};

type FastOrderModalProps = {
    open: boolean;
    onCancel: () => void;
    positions: FastOrderPosition[];
    onSuccess?: () => void;
    getContainer?: ModalProps["getContainer"];
};

const StyledFastOrderModal = styled(Modal)`
    top: 20%;

    .ant-modal-content {
        padding: 78px 108px;

        @media screen and (max-width: 999px) {
            padding: 48px 28px;
        }
    }

    .ant-modal-body {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: initial;
        position: relative;
    }

    .closeBtn {
        cursor: pointer;
        position: absolute;
        right: 0;
        top: 0;
    }

    h1 {
        font-size: 28px;
        color: #311c1c;
        font-weight: 600;
        margin-bottom: 40px;
        width: 100%;
        text-align: center;
    }

    .ant-form {
        display: flex;
        flex-direction: column;
        max-width: 350px;
        width: 100%;
        align-items: center;

        label {
            font-size: 18px;
            color: #8a8a8a;
        }

        .ant-form-item {
            display: flex;
            margin-bottom: 0;
            width: 100%;

            .ant-row {
                width: 100%;

                .ant-col {
                    flex: auto;
                }
            }
        }
    }

    .ant-form-item-explain-error {
        text-align: start !important;
    }

    .ant-form-item-control-input-content {
        display: flex;

        &:last-child {
            justify-content: center;
        }
    }

    .ant-input {
        border-radius: 4px;
        font-size: 18px;
        padding: 16px 24px;
        line-height: 18px;
    }

    .ant-btn {
        width: 172px;
        margin-top: 45px;
        font-weight: 500;
        font-size: 18px;
        line-height: 140%;
        background: #5B77CB;
        border: none;
        height: auto;
        padding: 15px;
        border-radius: 4px;

        span {
            color: #FFFFFF;
        }
    }
`;

function FastOrderModal({open, onCancel, positions, onSuccess, getContainer}: FastOrderModalProps) {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    return (
        <StyledFastOrderModal
            open={open}
            onCancel={onCancel}
            footer={null}
            closable={false}
            getContainer={getContainer}
            width={560}
        >
            <Close2SVG onClick={onCancel} className={"closeBtn"}/>
            <h1>Оформление заказа</h1>
            <Form
                form={form}
                requiredMark={false}
                layout={"vertical"}
                onFinish={(fields) => {
                    setLoading(true);
                    store.dispatch(makeUnauthorizedOrderAction({
                        Phone: `${fields.phoneZone}${fields.phoneNumber}`.replaceAll(" ", "").replaceAll("(", "").replaceAll(")", ""),
                        Email: fields.Email,
                        Positions: positions
                    })).then(() => {
                        form.resetFields();
                        onCancel();
                        onSuccess?.();
                    }).finally(() => {
                        setLoading(false);
                    });
                }}
            >
                <Form.Item label={"Номер телефона:"} style={{marginBottom: 28}}>
                    <Form.Item
                        initialValue={'+7'}
                        name={"phoneZone"}
                        rules={[
                            {
                                required: true,
                                message: "Поле не может быть пустым!"
                            },
                            {
                                validator: (_, value) => {
                                    if (value !== undefined && value.indexOf("_") !== -1) {
                                        return Promise.reject(new Error("Поле не может быть пустым!"));
                                    }

                                    return Promise.resolve();
                                }
                            }
                        ]}
                        style={{display: 'inline-block', width: 140}}
                    >
                        <MaskedInput mask={'+0[0][0]'}/>
                    </Form.Item>
                    <Form.Item
                        initialValue={"(___) ___ __ __"}
                        name={"phoneNumber"}
                        rules={[
                            {
                                required: true,
                                message: "Поле не может быть пустым!"
                            },
                            {
                                validator: (_, value) => {
                                    if (value !== undefined && value.indexOf("_") !== -1) {
                                        return Promise.reject(new Error("Поле должно быть заполнено полностью!"));
                                    }

                                    return Promise.resolve();
                                }
                            }
                        ]}
                        style={{display: 'inline-block', margin: '0 0 0 8px'}}
                    >
                        <MaskedInput mask={'(000) 000 00 00'}/>
                    </Form.Item>
                </Form.Item>
                <Form.Item
                    name={"Email"}
                    label={"Электронная почта:"}
                    rules={[
                        {
                            required: true,
                            message: "Поле является обязательным для заполнения!"
                        },
                        {
                            type: "email",
                            message: "Формат почты введен не верно!"
                        }
                    ]}
                >
                    <Input/>
                </Form.Item>
                <Form.Item style={{justifyContent: "center"}}>
                    <Button loading={loading} htmlType={"submit"}>Подтвердить</Button>
                </Form.Item>
            </Form>
        </StyledFastOrderModal>
    );
}

export default FastOrderModal;
